/**
 * Display helpers for the payment-plan schedule (US 4396). Status codes come from
 * Bss.Entities PaymentPlanSchedule; labels match b360's so agents and staff use the
 * same words on a phone call.
 */

/** Line kinds (PaymentPlanSchedule.KindInstallment / KindLateFee). */
export const SCHEDULE_KIND = {
  Installment: 'Installment',
  LateFee: 'LateFee',
};

/** Line statuses (PaymentPlanSchedule.Status*). */
export const SCHEDULE_LINE_STATUS = {
  Paid: 'Paid',
  Deferred: 'Deferred',
  PastDue: 'PastDue',
  Next: 'Next',
  Upcoming: 'Upcoming',
};

export const SCHEDULE_STATUS = {
  [SCHEDULE_LINE_STATUS.Paid]: {
    label: 'Paid',
    className: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  },
  [SCHEDULE_LINE_STATUS.Deferred]: {
    label: 'Deferred',
    className: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300',
  },
  [SCHEDULE_LINE_STATUS.PastDue]: {
    label: 'Past due',
    className: 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300',
  },
  [SCHEDULE_LINE_STATUS.Next]: {
    label: 'Next due',
    className: 'bg-teal-100 text-teal-700 dark:bg-teal-900/40 dark:text-teal-300',
  },
  [SCHEDULE_LINE_STATUS.Upcoming]: {
    label: 'Upcoming',
    className: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
  },
};

/** MM/DD/YYYY from an ISO date, '—' when empty. Date-only, so no timezone shift. */
export const formatScheduleDate = (value) => {
  if (!value) return '—';
  const [datePart] = String(value).split('T');
  const [y, m, d] = datePart.split('-');
  if (!y || !m || !d) return '—';
  return `${m}/${d}/${y}`;
};
